<template>
  <transition name="loading-">
    <div class="loading" v-if="isShow">
      <div class="loading__wrapper">
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
        <div class="loading__circle" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  background: rgba(255, 255, 255, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  &--enter-active,
  &--leave-active {
    transition: opacity 0.5s ease 0s;
  }
  &--enter,
  &--leave-to {
    opacity: 0;
  }
  &__wrapper {
    position: relative;
  }
  &__circle {
    background: #333;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin: -5px 0 0 -5px;
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;

    $max: 8;
    $s: 0.15;
    @for $i from 1 through $max {
      &:nth-child(#{$i}) {
        transform: rotate(#{360 / $max * $i}deg) translate(30px, 0);
        animation: spinner linear #{$s * $max}s infinite #{$s * ($i - 1)}s;
      }
    }
  }
}

@keyframes spinner {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0.8;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
</style>
